// Dreamy animated ambient backdrop (navy/royal/turquoise) used by splash & player.
export const AmbientBackdrop = ({ dark = false }) => (
  <div className="absolute inset-0 overflow-hidden" aria-hidden="true">
    {dark && <div className="absolute inset-0 bg-navy" />}
    <div className={`absolute -top-24 -left-16 w-72 h-72 rounded-full blur-3xl animate-blob ${dark ? "bg-royal/40" : "bg-royal/20"}`} />
    <div className={`absolute top-20 -right-20 w-80 h-80 rounded-full blur-3xl animate-blob ${dark ? "bg-turq/40" : "bg-turq/20"}`} style={{ animationDelay: "3s" }} />
    <div className={`absolute bottom-0 left-1/4 w-72 h-72 rounded-full blur-3xl animate-blob ${dark ? "bg-royal/30" : "bg-turq/10"}`} style={{ animationDelay: "6s" }} />
  </div>
);

export default AmbientBackdrop;
